import axios from 'axios'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
import { getJWT } from 'src/helper/localStore/getJWT'
import { SendEmailInputDTO } from './emailDTO'

class EmailServices {
  async sendEmail(body: SendEmailInputDTO): Promise<any> {
    try {
      body['jwt'] = getJWT()!

      const res = await axios.post(
        `${process.env.REACT_APP_URL_NOTIFICATION}/notification/send-mail/`,
        body,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteEmail(id: number): Promise<any> {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_NOTIFICATION}/notification/email/${id}/`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

}
export const emailServices = new EmailServices()
